import type { useLingui } from '@lingui/react/macro';
import { formatExpiryDate, DEFAULT_EXPIRY_THRESHOLD_DAYS } from '@pantry/shared';

/**
 * Get expiry display text with date based on urgency.
 * Uses the resolved threshold to determine the "fresh" boundary.
 */
export function getExpiryDisplayText(
  daysUntilExpiry: number | null,
  expiryDate: string | null | undefined,
  t: ReturnType<typeof useLingui>['t'],
  locale: string,
  thresholdDays?: number
): string {
  if (daysUntilExpiry === null || !expiryDate) return '';

  const formattedDate = formatExpiryDate(expiryDate, locale);
  const displayThreshold = thresholdDays ?? DEFAULT_EXPIRY_THRESHOLD_DAYS;

  if (daysUntilExpiry < 0) {
    return t`Expired ${formattedDate}`;
  }
  if (daysUntilExpiry === 0) {
    return t`Today (${formattedDate})`;
  }
  if (daysUntilExpiry === 1) {
    return t`Tomorrow`;
  }
  if (daysUntilExpiry <= displayThreshold) {
    return t`${formattedDate} (${daysUntilExpiry}d)`;
  }
  // Fresh - beyond threshold, just show date
  return formattedDate;
}
